module.exports = __webpack_public_path__ + "img/fig16.de287788.jpg";